import clsx from 'clsx';
import React from 'react';
import { useTrilogyContext } from '../../context';
import { hashClass } from '../../helpers';
import { getColorStyle, TrilogyColor } from '../../objects';
/**
 * Range Component
 * @param min {number} min length
 * @param max {number} max length
 * @param label {string} label of range
 * @param labelValueCursorMin {string} label to display next to value display
 * @param labelValueCursorMax {string} label to display next to value display
 * @param onChangeMin
 * @param onChangeMax
 * @param onChange {function} (Native)
 * @param nameMin {string} name input min
 * @param idMin {string} id input min
 * @param nameMax{string} name input max
 * @param idMax {string} id input max
 * @param testId
 * @param gap {number} space max between min and max cursor
 * @param valueCursorMin {number} number of input min
 * @param valueCursorMax {number} number of input max
 */
const Range = ({ min, max, label, valueCursorMin, valueCursorMax, labelValueCursorMin, labelValueCursorMax, onChangeMin, onChangeMax, nameMin, idMin, nameMax, idMax, testId, gap = 0, }) => {
    const { styled } = useTrilogyContext();
    const [cursorMin, setCursorMin] = React.useState(valueCursorMin !== null && valueCursorMin !== void 0 ? valueCursorMin : 0);
    const [cursorMax, setCursorMax] = React.useState(valueCursorMax !== null && valueCursorMax !== void 0 ? valueCursorMax : max);
    const refTrack = React.useRef(null);
    React.useEffect(() => {
        if (refTrack.current) {
            const track = refTrack.current;
            track.style.background = `linear-gradient(to right, ${getColorStyle(TrilogyColor.GREY_LIGHT)} ${(cursorMin / max) * 100}% , ${getColorStyle(TrilogyColor.SECONDARY)} ${(cursorMin / max) * 100}% , ${getColorStyle(TrilogyColor.SECONDARY)} ${(cursorMax / max) * 100}%, ${getColorStyle(TrilogyColor.GREY_LIGHT)} ${(cursorMax / max) * 100}%) `;
        }
    }, [cursorMin, cursorMax, refTrack]);
    React.useEffect(() => {
        setCursorMin(valueCursorMin || 0);
    }, [valueCursorMin]);
    React.useEffect(() => {
        setCursorMax(valueCursorMax || max);
    }, [valueCursorMax, max]);
    const handleChangeCursorMin = React.useCallback((e) => {
        if (Number(e.target.value) < cursorMax - gap)
            setCursorMin(Number(e.target.value));
    }, [cursorMax, cursorMin]);
    const handleChangeCursorMax = React.useCallback((e) => {
        if (Number(e.target.value) > cursorMin + gap)
            setCursorMax(Number(e.target.value));
    }, [cursorMax, cursorMin]);
    const handleMouseUpMin = React.useCallback(() => {
        if (onChangeMin) {
            onChangeMin({
                inputName: nameMin,
                inputValue: cursorMin,
            });
        }
    }, [onChangeMin, nameMin, cursorMin]);
    const handleMouseUpMax = React.useCallback(() => {
        if (onChangeMax) {
            onChangeMax({
                inputName: nameMax,
                inputValue: cursorMax,
            });
        }
    }, [onChangeMax, nameMax, cursorMax]);
    return (React.createElement("div", { "data-testid": testId, className: hashClass(styled, clsx('range-container')) },
        React.createElement("label", { className: hashClass(styled, clsx('range-label')) }, label),
        React.createElement("div", { className: hashClass(styled, clsx('range')) },
            React.createElement("div", { ref: refTrack, className: hashClass(styled, clsx('range-track')) }),
            React.createElement("input", { "data-testid": `${testId}_min`, className: hashClass(styled, clsx('range-cursor range-cursor-min')), onMouseUp: handleMouseUpMin, onChange: handleChangeCursorMin, onTouchEnd: handleMouseUpMin, value: cursorMin, type: 'range', min: min, max: max, name: nameMin, id: idMin, "aria-label": label }),
            React.createElement("input", { "data-testid": `${testId}_max`, className: hashClass(styled, clsx('range-cursor range-cursor-max')), onMouseUp: handleMouseUpMax, onChange: handleChangeCursorMax, onTouchEnd: handleMouseUpMax, value: cursorMax, type: 'range', min: min, max: max, name: nameMax, id: idMax, "aria-label": label })),
        React.createElement("div", { className: hashClass(styled, clsx('range-values')) },
            React.createElement("div", null,
                React.createElement("span", { className: hashClass(styled, clsx('range-value-min')) }, cursorMin),
                labelValueCursorMin && React.createElement("span", null,
                    " ",
                    labelValueCursorMin)),
            React.createElement("div", null,
                React.createElement("span", { className: hashClass(styled, clsx('range-value-max')) }, cursorMax),
                labelValueCursorMax && React.createElement("span", null,
                    " ",
                    labelValueCursorMax)))));
};
export default Range;
//# sourceMappingURL=Range.js.map